import ListItem from '@material-ui/core/ListItem'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Checkbox from '../Checkbox'

const styles = theme => ({
  root: {
    borderRadius: 4,
    border: theme.borders.default,
    padding: 0,
    '&.Mui-disabled': {
      backgroundColor: theme.inputField.inputBGDisabled,
      opacity: theme.inputField.inputDisabledOpacity,
    },
  },
  layout: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  labelDescription: {
    display: 'flex',
    flexDirection: 'column',
    '& > span': {
      fontSize: theme.typography.fontSizetiny,
      color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
      lineHeight: 1,
      paddingBottom: 4,
    },
  },
})

function Listitem({
  classes,
  className,
  isChecked,
  children,
  label,
  description,
  type,
  onSelected,
  OverrideComponent,
  forwardRef,
  id,
  fullWidthItem,
  dataTestId,
  ...rest
}) {
  let Component = null
  if (type === 'checkbox' || !type) {
    Component = (
      <Checkbox checked={isChecked} tabIndex={0} disableRipple disabled={rest.disabled} data-testid={dataTestId} />
    )
  } else if (type === 'radio') {
    Component = <Radio color="primary" checked={isChecked} disabled={rest.disabled} data-testid={dataTestId} />
  }
  return (
    <ListItem
      className={cn(className, classes.root)}
      button
      onClick={onSelected}
      onKeyPress={event => event.key === 'Enter' && onSelected(event)}
      ref={forwardRef}
      id={id}
      {...rest}
    >
      <div className={classes.layout}>
        {children}
        {(label || description) && (
          <div className={classes.labelDescription}>
            {label && label}
            {description && <span>{description}</span>}
          </div>
        )}
        {OverrideComponent || Component}
      </div>
    </ListItem>
  )
}

export default withStyles(styles)(Listitem)
